import React from "react";
import { useTranslation } from 'react-i18next';
import Spinner from "./ui/spinner";

const RelationsList = ({
  relationships,
  nodes,
  loading,
  setExpandedRelation,
  deleteRelationship,
}) => {
  const { t } = useTranslation();
  if (!relationships || relationships.length === 0) {
    return (
      <div className="empty-relationships">
        <div className="empty-state">
          <span className="empty-icon">⚠️</span>
          <p className="empty-message">{t('relationsList.noRelationsFound')}</p>
          <p className="empty-description">
            {t('relationsList.useCreateRelationSection')}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="relationships-grid">
      {relationships.map((rel, index) => (
        <div
          key={index}
          className={`relationship-card ${rel.relationshipType === "DEPENDS_ON"
            ? "depends-type"
            : rel.relationshipType === "INFLUENCES"
              ? "influences-type"
              : "connected-type"
            }`}
          onClick={() => setExpandedRelation(rel)}
        >
          <div className="relationship-visualization">
            <div className="source-node">
              <div className="node-circle">
                <span className="node-icon">📄</span>
              </div>
              <div className="node-label truncate-text" title={rel.nodeName1}>
                {rel.nodeName1}
              </div>
            </div>
            <div className="relationship-arrow">
              <div className="arrow-line"></div>
              <div className="arrow-type">{rel.relationshipType}</div>
            </div>
            <div className="target-node">
              <div className="node-circle">
                <span className="node-icon">📄</span>
              </div>
              <div className="node-label truncate-text" title={rel.nodeName2}>
                {rel.nodeName2}
              </div>
            </div>
          </div>
          <div className="relationship-actions">
            <button
              className="expand-relationship-btn"
              onClick={e => {
                e.stopPropagation();
                setExpandedRelation(rel);
              }}
            >
              <span className="btn-icon">🔍</span>
              <span className="btn-text">{t('relationsList.details')}</span>
            </button>
            <button
              onClick={e => {
                e.stopPropagation();
                deleteRelationship(
                  rel.nodeName1,
                  rel.nodeName2,
                  rel.relationshipType
                );
              }}
              disabled={loading}
              className="delete-relationship-btn"
            >
              {loading ? <Spinner /> : <span className="btn-icon">🗑️</span>}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RelationsList;